import Timer from "@/utils/Timer";
import API from "@/utils/API";

class VideoStream {
  constructor(app) {
    this.app = app;
    this.clock = 1;
  }

  init() {
    // console.log(this.app);
    // if (!this.app.$root.isPilotLogin) {
    //   Timer.addRequest("videostream", {
    //     timer: async () => {
    //       if (this.clock % 3 == 0) {
    //         this.getVideoStream();
    //       }
    //       this.clock += 1;
    //     },
    //   });
    // }
  }

  async getVideoStream() {
    if (this.app.$root.isPilotLogin) return;
    this.app.$root.videoStream = await API.get("videostream", {});
  }
}

export default VideoStream;
